module.exports = __webpack_public_path__ + "static/1732685807992/media/survey-icon.daca414f.svg";